/**
 * 任务调度设置接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SystemProductManageService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;


   constructor(
     private http: SwHttpClientService
   ) {
   }

  //#region scheduleTask 产品设置接口


  /**
   * 查询产品列表
   * @param param
   * @returns {Observable<any>}
   */
  getSystemProductList(param) {
    const url = this.prefix + 'systemProduct/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 删除产品
   *
   * @param param
   */
  deleteSystemProductById(param) {
    const url = this.prefix + 'systemProduct/deleteBatch';
    return this.http.Post(url, param);
  }

  /**
   * 查看产品信息
   *
   * @param param
   */
  getSystemProductInfo(param) {
    const url = this.prefix + 'systemProduct/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 添加产品
   *
   * @param param
   */
  saveSystemProduct(param) {
    const url = this.prefix + 'systemProduct/save';
    return this.http.Post(url, param);
  }

  /**
   * 修改产品
   *
   * @param param
   */
  updateSystemProduct(param) {
    const url = this.prefix + 'systemProduct/updateById';
    return this.http.Post(url, param);
  }


  //#endregion

}
